/*
 * @author: yanhoup
 * @description: OBKoro1
 */

export const defaultFusionTable = {
  search: { submit: () => {}, reset: () => {} },
};

export { pageNumberProps, IS_NEED } from './basicConst';

export {
  ORDER_TIME,
  ORDER_MODULE_STATUS,
  ABNORMAL_CAUSE,
  SLA_STATUS,
  SLA_TYPE,
  ARRAIVAL_TYPE,
  CARRIER_TYPE,
  CAUSE_BY,
  CAUSE_LIST,
  IS_RECEIVE,
  IS_UNLOAD,
  IS_NEW_ITEM,
  IN_ORDER_CHECKBOX_TYPE,
  INBOUND_DETAIL_TABLE,
  OUTBOUND_DETAIL_TABLE,
  BOUNCE_DETAIL_TABLE,
  OPERATE_TYPE,
  OPERATE_CONTENT,
  IN_OPERATE_CON,
  IN_OPERATE_TYPE,
  BOUNCE_ORDER,
  BOUNCE_ORDER_STATUS,
  BOUNCE_ORDER_TYPE,
  BOUNCE_ORDER_TIME,
  BOUNCE_ORDER_DETAIL_TAB,
  IN_ABNORMAL_CAUSE,
  PRINT_BOX_TYPE,
  IS_CLOSE_BATCH,
  VAS_ORDER,
  VAS_ORDER_TYPE,
  VAS_OPERATE_PERIOD,
  VAS_ENTRUST_PERIOD,
  VAS_TASK_PERIOD,
  VAS_SERVICE_TYPE,
  VAS_SERVICE_OPERATE,
  VAS_TASK_PERIOD_TAB,
  VAS_SKU_STOCK_QUALITY,
  VAS_ORDER_SOUCE,
  VAS_STOCK_QUALITY,
  VAS_BEMODIFIED_STOCK_QUALITY,
  VAS_BEMODIFIED_STOCK_QUALITY_E,
  VAS_BEMODIFIED_STOCK_QUALITY_B,
  VAS_DEAL_TYPE,
  LABEL_TEXT,
  VAS_PHOTOT_TYPE,
  VAS_SERVICE_KIND,
  VAS_OPERATE_LOG,
  VAS_CHANGE_LABEL_FLAG,
  GENERAL_TAB,
  VAS_SERVICE_API,
  BOUNCE_OPERATE_TYPE,
  BOUNCE_OPERATE_CONTENT,
  PORTAL_SERVICE_API,
} from './OrderConst';

export {
  WORK_TYPE,
  CONTAINER_TYPE,
  WORK_STATUS,
  ENABLE_STATUS,
  TYPE,
  NO_IN_TYPE,
  ASSORT_STATUS,
  OPERATE_FLOOR_TYPE,
  AREA_TYPE,
  SUBMIT_STATUS,
  PACKING_TYPE,
  BUSINESS_TYPE,
  PACKING_TEXTURE,
  PACKING_PRICE,
  OPA_PRINT_LABEL,
  BASKET_PRINT_LABEL,
  PALLET_PRINT_LABEL,
  BASEDATASERVICE,
  AGENT_TYPE,
  AGENT_PRINT_USERANGE,
  AGENT_ROTATEFLIP,
  AGENT_PRINTMODE,
  AGENT_PRINTSWITCH,
  AGENT_STATE,
  ATRICLE_TYPE,
  MUL_PACKAGE_CHANGE_NO,
  MUL_PACKAGE_VERIFICATION_TYPE,
  DD_LAN_TYPE,
  DD_PUSH_TIME_TYPE,
  DD_PRODUCT_TYPE,
  CUSTOMER_TYPE_LOCATION,
  WEEK_ENUM,
  DESTORY_TYPE,
  CustomerCodeOrCustomerId,
  OUT_PACKAGE_TYPE,
  OUT_PACKAGE_MATERIAL,
  PACKAGE_USE_EXCEPTION_STATUS,
  PACKAGE_USE_EXCEPTION_RESULT,
  TASK_TYPE,
} from './BaseDataConst';

export {
  RECEIVING_TIME,
  RECEIVING_TAB_STATUS,
  RECEIVING_PERSON_TYPE,
  RECEIVING_ORDER,
  RECEIVING_PUSH_STATUS,
  RECEIVING_OPERATION_NODE,
  STOCK_ADJUST_OPERATION_NODE,
  PICKING_ORDER,
  PICKING_SKU_TYPE,
  PICKING_TIME,
  PICKING_TAB_STATUS,
  PICKING_DETAIL_STATUS,
  PICKING_PERSON,
  IS_MERGE,
  MOVE_ORDER,
  MOVE_DOWN_ORDER,
  MOVE_TAB_STATUS,
  MOVE_TABLE_STATUS,
  MOVE_TIME,
  AGV_SERVICE,
  PUSH_STATUS,
  PUSH_TYPE,
  PUSH_AGV,
  SKU_PUSH_NODE,
  SKU_PUSH_STYLE,
  SKU_PUSH_RESULT,
  TALLY_NO_TYPE,
  TALLY_TYPE,
  TALLY_TIME,
  TALLY_PERSON_TYPE,
  AGV_ABNOR_ORDER,
  AGV_ABNOR_PERSON,
  AGV_ABNOR_TIME,
  AGV_ABNOR_STATUS,
  INVENTORY_ADJUST_TYPE,
  INVENTORY_ADJUST_REASON,
  AGV_OPERATE_PERIOD,
  AGV_OPERATE_TYPE,
  GIWS_AUTO,
} from './AgvConst';

export {
  STOCK_QUALITY,
  BUSINESSTYPE,
  NEW_PUTAWAY_TYPE,
  PUTON_TYPE,
  PUTAWAY_TYPE,
  ABNOR_PUTON_TYPE,
  ABNOR_PUTON_TYPE_LIST,
  PUTAWAY_ABNOR_TIME,
  NEW_RECEIPT_TYPE,
  RECEIPT_NO,
  RECEIPT_TYPE,
  RECEIPT_ANBOR_TIME,
  DISCHARGE_ANBOR_TIME,
  TAB_STATUS,
  OPERATIONCODE,
  INBOUNDSERVICE,
  CARGO_TYPE_LIST,
  PAKEAGE_TAB,
  RESERVATIONTYPE,
  SHOUHUOSTATE,
  CONTAINERTYPE,
  YIKUSTATUS,
  MOVEKU_ACTION_STATUS,
  YIKUALLSTATUS,
  YUYUENOTYPE,
  TRANSPORTYPE,
  TWOTRANSPORTYPE,
  RECEVINGFULFILLSTATUS,
  CARRIERTYPE,
  ARRIVECONFIRMSTATUS,
  DIFFERENCE_STATUS,
  INBOUND_SOURELIST,
  PAKEAGE_TAB_STATUS,
  BOUNCE_RECEIPT_ORDER,
  BOUNCE_RECEIPT_TIME,
  BOUNCE_RECEIPT_STATUS,
  BOUNCE_PUTAWAY_ORDER,
  BOUNCE_PUTAWAY_TIME,
  BOUNCE_PUTAWAY_STATUS,
  BOUNCE_PUTAWAY_DETAIL_ORDER,
  BOUNCE_PUTAWAY_ABNOR_ORDER,
  BOUNCE_QUALITY_STATUS,
  BOUNCE_PUTAWAY_TYPE,
  BOUNCE_OPERATE_STEP,
  IBOUND_OPERATE_CONTENT,
  RESERVATIONTYPES,
  RECEIPT_GOODS_TAB,
  GOOD_ABNOR_STATUS,
  GOOD_ABNORMAL_CATEGORIES,
  GOOD_ABNOR_TYPE,
  LOG_DEPARTMENT,
  LOG_REMARK,
  DEAL_SUGGESTION,
  LOGISTICS_PACKAGING,
  YUYUESTATUS,
  BUSINESSTYPEPRODULE,
  GOODSABNOR_YES_NO,
  REPORT_LIST,
  EATIMES,
  EVENT_CODES,
  INBOUND_TALLY_STATUS,
  TALLY_STATUS,
  TALLY_EXCEPTION_TYPE,
  TALLY_SUBEXCEPTION_TYPE,
  RESERVATION_LEAD_SEAL_STATUS,
  RESERVATION_HAS_POD,
  DEAL_OPINION_CATEGORIES,
  RECEIVE_PATH,
} from './inbound';

export {
  SORT_STATUS,
  ORDER_TYPE,
  ZONECODE_TYPE,
  MANUALREMIT_TIME,
  CHANNEL,
  PICK_ORDER_STATUS,
  CARGO_TYPE,
  WAREHOUSE_AREAR,
  ORDER_ORIGIN,
  PICK_SEARECH,
  PICK_DETAIL_SEARECH,
  PICK_STATUS,
  PICK_TAB_STATUS,
  STOCK_STATUS,
  OUTBOUND_URL,
  SORT_STEP_STATUS,
  OPERATION_OUTBOUND_URL,
  DELIVER_STATUS,
  DELIVER_ORDER_STATUS,
  DISPATCHCAR_STATUS,
  NO_TYPE,
  OUT_ORDER_STATUS,
  OUT_ORDER_TYPE,
  OUT_TIME_TYPE,
  CHANGE_NO_TYPE,
  RETURN_TYPE,
  OUT_ORDER_ORIGIN,
  PICK_SEARECH_TYPE,
  PICK_TIME_TYPE,
  OUT_CAR_STATUS,
  OUT_PICK_STATUS,
  OUT_OPERATE_TYPE,
  PICK_TYPE,
  PACK_STEP_TYPE,
  OUT_OPERATE_DETAIL_TYPE,
  OUTBOUND_BUSINESS_TYPE,
  OUTBOUND_PRODUCT_TYPE,
  OUTBOUND_PICK_ORDER_TYPE,
  OUTBOUND_REMITTANCE_SLIP_FAILURE,
  COLLECT_WAVE_TYPE,
  IS_LOGISTICS_PACKAGING,
  OUT_SKU_QUERY,
  SORTING_COLLECT_TASK_TYPE,
  SKU_GROUP_ORDER_STATUS,
  RETURN_PORT,
  BUSINESSTYPERETURN,
  OUT_SEARCH_DROPDOWN,
  INSPECT_SEARCH_DROPDOWN,
  DISPATCH_CAR_STEP_TYPE,
  OUTBOUND_BMG_BRAND_TYPE,
  AUTO_WAVE_ORDER_TASK_TYPE,
  DWS_TIME_TYPE,
  INSPECT_RESULT,
  INSPECT_SKU_SEARCH_DROPDOWN,
  PICK_PRODUCT_TYPE,
  OUTBOUND,
} from './outbound';

export {
  IS_SPLIT,
  DEVAN_TIME_TYPE,
  DIFF_TYPE,
  DEVAN_LIST_TYPE,
  REPLENISH_STATUS,
  REPLENISH_TYPE,
  REPLENISH_SERVICES,
  ENTER_DIFFER,
  ACTION_TYPE,
  ABNOR_TYPE,
  REPLE_CARGO_TYPE,
  REPLE_ABCTYPE,
  INVENTORY_LIST_TAB,
  INVENTORY_FIND_TAB,
  CHECK_MODE,
  IS_SPLICE,
  RANGE_SOURCE,
  CHECK_TYPE,
  CHECK_STATUS,
  CHECK_TASK_TYPE,
  INVENTORY_ANBOR_TAB,
  IS_DIFF,
  CHECK_MODE_ALL,
  CHECK_TYPE_ALL,
  INVENTORY_STATUS,
  IS_DIFF_TABLE,
  MOVEKU_ACTION_TYPE,
  INVENTORY_STRATEGY_MODEL,
  INVENTORY_STRATEGY_PIN_LEVEL,
  INSIDE_SKU_QUERY,
  BASEDATA_SERVICES,
  INSIDE_SERVICES,
  REPLENISH_TIME_TYPE,
} from './inSideConst';

export {
  CONTAINER_OPERATE_TYPE,
  GOODS_CONTAINER_TYPE,
  Y_N,
  TRUE_FALSE,
  VIRTUAL_LOC_ADJ_REASON_LIST,
  STOCK_QUALITYS,
  ADJUSTYPE,
  STOCKTYPE,
  INVENORYNUMTYPE,
  STOCK_DIFF_MANAGE,
  STOCK_SEARCH_ADJUST_TYPE,
  STOCK_SEARCH_ADJUST_ADD_RESON,
  STOCK_SEARCH_ADJUST_SUB_RESON,
  STOCK_SEARCH_ADJUST_SUB_RMA_RESON,
  STOCK_DIFF_EXCEPTE_TYPE,
  DIFF_SKU_TYPE,
  RETRNSKU_LIST_CONST,
  GOODS_CARGO_TYPE,
  PACKAGE_LAN_TYPE,
  STORAGE_TYPE,
  DIFFTYPE,
  INVDIFFERENTJOBSTATUS,
  DIFFERENTJOBBUSINESSTYPE,
} from './GoodsConst';

export {
  PROJECT_TYPES,
  PRODUCTION_TYPES,
  OPERAITION_STATUS,
  ONLINE_STATUS,
  ORDER_TYPES,
  SLA_TYPES,
  CARRAGE_MODES,
  TRANSPORTATIONS,
  FILTER_TYPES,
  PERSON_TYPE,
  EFFECT_TYPE,
  SERVICE_INBOUND_BOARD_DATA,
  INBOUND_BOARD_TYPE,
  OUTBOUND_BOARD_TYPE,
  INBOUND_BOARD_DATA,
  OUTBOUND_BOARD_DATA,
  EFFICIENCY_DATA,
  PERSON_DATA,
  RED_DATA,
  GREY_DATA,
  HELP_LIST,
  MESSAGE_LIST,
  BOOK_TYPE,
  BILLBOARD_INBOUND_ORDER_STATUS,
  PERSON_CONFIG_LABEL,
  PERSON_BOARD_LABELS,
  PERSON_BOARD_TYPE,
} from './billboard';

export {
  PERSON_LINK_CODE,
  INVENTORY_ERROR_NODE,
  INVENTORY_ERROR_CURRENT_NODE,
  INVENTORY_ERROR_STATUS,
  INVENTORY_AFFECT_CHECK,
  INVENTORY_ERROR_LINK,
  INVENTORY_MONITOR_SERVICE,
  INVENTORY_SERVICE,
  INVENTORY_INTELLIGENT,
  CONSIGMENT_STATUS,
  OUT_INVENTORY_STATUS,
  DATA_SERVICE,
} from './serviceConst';

export {
  ALLOCATE_TIME_TYPE,
  ALLOCATE_ORDER_STATUS,
  ASSORT_LIST_STATUS,
  ALLOCATE_TASK_TYPE,
  ALLOCATE_URL,
  ALLOCATE_NO_TYPE,
  GROUP_LIST_STATUS,
  DELIVERY_LIST_STATUS,
  SHIPPED_STATUS,
  RETURN_STEPLIST,
  RETURNSERVICE_LIST_TER,
} from './allocateConst';

export {
  FBA_ORDER_TYPE,
  OPERATION_DESC_TYPE,
  IS_TYPE,
  FROM_WAREHOUSE_MODE,
  SHIPPING_TYPE,
  FBA_IN_ORDER_TYPE,
  FBA_STOCKING_STATE,
  FBA_DELIVER_TYPE,
  FBA_TRAQNSPORT_TYPE,
} from './fbaConst';

export { PATTERN } from './returnConst';
